"use client"
import { determineABTestVariation } from "utils/ab-test"

export enum NearByPropertiesABTestVariants {
  V0_VERSION = "v0",
  V1_VERSION = "v1",
}

export const VARIANT_KEY = "near_by_properties_ab_test"
export const VARIANT_OPTIONS: string[] = [
  NearByPropertiesABTestVariants.V0_VERSION,
  NearByPropertiesABTestVariants.V1_VERSION,
]

export const VARIANT_WEIGHTS: number[] = [50, 50] as const
export const DEFAULT_VARIANT = NearByPropertiesABTestVariants.V0_VERSION

export const getNearByPropertiesABTestVariant = () => {
  return determineABTestVariation(
    VARIANT_KEY,
    VARIANT_OPTIONS,
    VARIANT_WEIGHTS,
    DEFAULT_VARIANT,
  ) as NearByPropertiesABTestVariants
}

// const useNearByPropertiesABTesting = () => {
//   const [variant, setVariant] = useState<NearByPropertiesABTestVariants | null>(null)

//   useEffect(() => {
//     const selectedVariant = getNearByPropertiesABTestVariant()

//     setVariant(selectedVariant)
//   }, [])

//   return variant
// }

// export default useNearByPropertiesABTesting
